export const editDataFormName = "editData";
export const editDataFieldConfig = {
  type: {
    fieldName: "type",
    label: "Type of upload",
    required: true,
  },
  location: {
    fieldName: "location",
    label: "Customer",
    required: true,
  },
  agent: {
    fieldName: "agent",
    label: "Agent",
    required: true,
  },
  teamLeader: {
    fieldName: "teamLeader",
    label: "Team leader",
    required: true,
  },
  description: {
    fieldName: "description",
    label: "Description",
    required: false,
  },

  denialReason: {
    fieldName: "denialReason",
    label: "Denial reason",
    required: false,
  },

  division: {
    fieldName: "division",
    label: "Division",
    required: true,
  },
  desk: {
    fieldName: "desk",
    label: "Desk #",
    required: true,
  },
  date: {
    fieldName: "date",
    label: "Date",
    type: "date",
    required: true,
  },

  shift: {
    fieldName: "shift",
    label: "Shift",
    required: true,
  },
  companyRelation: {
    fieldName: "companyRelation",
    label: "Company Relation",
    required: true,
  },

  note: {
    fieldName: "note",
    label: "Note",
    type: "text",
    required: false,
  },
  shiftManager: {
    fieldName: "shiftManager",
    label: "Shift manager on duty",
    required: false,
  },
};

export const formName = "reviewFilters";
export const fieldConfig = {
  type: {
    fieldName: "type",
    label: "Great Telepresence Type",
    type: "text",
    required: false,
  },

  agent: {
    fieldName: "agent",
    label: "Agent",
    type: "text",
    required: false,
  },

  approvedOptions: {
    fieldName: "approvedOption",
    label: "Approved",
    type: "text",
    required: false,
  },

  fromDate: {
    fieldName: "fromDate",
    label: "From Date",
    type: "date",
    required: false,
    changeHandles: () => {},
  },
  toDate: {
    fieldName: "toDate",
    label: "To Date",
    type: "date",
    required: false,
  },
};
